<script>
  import "./scss/styles.scss"

  import { Router, Route } from "svelte-routing"

  import Home from "./routes/Home.svelte"
  import Channel from "./routes/Channel.svelte"
  import Template from "./routes/Template.svelte"
  import Event from "./routes/Event.svelte"
  import CreateEvent from "./routes/CreateEvent.svelte"
  import Monitor from "./routes/Monitor.svelte"

  import api from "./services/api"
  import { init } from "./services/users"

  import { user, templates, channels } from "./stores.js"

  async function initialize() {
    try {
      await api.init({ hostname: window.location.hostname })
      await init()
    } catch (e) {
      console.error(e)
      throw e
    }
  }
</script>

<div class="container main">
  {#await initialize()}
    loading...
  {:then result}
    {#if $user}
      <Router>
        <Route path="" component={Home} />

        <Route path="events" let:params>
          <Event />
        </Route>

        <Route path="events/:name/channels" let:params>
          <Channel name={params.name} />
        </Route>

        <Route path="events/:name/channels/:channel/templates" let:params>
          <Template name={params.name} channel={params.channel} />
        </Route>

        <Route path="events/:name/channels/:channel" let:params>
          <CreateEvent name={params.name} channel={params.channel} />
        </Route>

        <Route path="channels/:channel/events/:name" let:params>
          <Event channel={params.channel} name={params.name} />
        </Route>

        <Route path="events/:name" let:params>
          <Monitor name={params.name} />
        </Route>
      </Router>
    {/if}
  {:catch e}
    <div>ops, something wrong... {e}</div>
  {/await}
</div>

<style>
</style>
